import { defineMessages } from 'react-intl';

export default defineMessages({
    quoteTitle: {
        id: 'gateway.views.new-quote-account-search.New Quote: Search for Existing Account',
        defaultMessage: 'New Quote: Search for Existing Account',
    },
    accountType: {
        id: 'gateway.views.new-quote-account-search.ContactType',
        defaultMessage: 'Account Type',
    },
    commercial: {
        id: 'gateway.views.new-quote-account-search.ContactType.Company',
        defaultMessage: 'Commercial',
    },
    personal: {
        id: 'gateway.views.new-quote-account-search.ContactType.Person',
        defaultMessage: 'Personal',
    },
    person: {
        id: 'gateway.views.new-quote.Person',
        defaultMessage: 'Person',
    },
    name: {
        id: 'gateway.views.new-quote.Name',
        defaultMessage: 'Name',
    },
    company: {
        id: 'gateway.views.new-quote.Company',
        defaultMessage: 'Company',
    },
    organizationName: {
        id: 'gateway.views.new-quote.organizationName',
        defaultMessage: 'Organization Name',
    },
    city: {
        id: 'gateway.views.new-quote.City',
        defaultMessage: 'City',
    },
    zipCode: {
        id: 'gateway.views.new-quote.ZipCode',
        defaultMessage: 'ZIP Code',
    },
    state: {
        id: 'gateway.views.new-quote.State',
        defaultMessage: 'State',
    },
    cancel: {
        id: 'gateway.views.new-quote.Cancel',
        defaultMessage: 'Cancel',
    },
    search: {
        id: 'gateway.views.new-quote-account-search.Search',
        defaultMessage: 'Search',
    },
    firstName: {
        id: 'gateway.views.new-quote.FirstName',
        defaultMessage: 'First Name',
    },
    lastName: {
        id: 'gateway.views.new-quote.LastName',
        defaultMessage: 'Last Name',
    },
    possibleAccountMatches: {
        id: 'gateway.views.new-quote-account-search.Possible Account Matches',
        defaultMessage: 'Possible Account Matches',
    },
    searchAgain: {
        id: 'gateway.views.new-quote-account-search.Search Again',
        defaultMessage: 'Search Again',
    },
    continueNewCustomer: {
        id: 'gateway.views.new-quote-account-search.Continue as a New Customer',
        defaultMessage: 'Continue as a New Customer',
    },
    possibleBaseQuote: {
        id: 'gateway.views.new-quote-account-search.The following account(s) may represent this customer. Please review, and if there is a match, select the account to use for this quote.',
        defaultMessage:
            'The following account(s) may represent this customer. Please review, and if there is a match, select the account to use for this quote.',
    },
    detailsAccount: {
        id: 'gateway.views.new-quote-account-search.You do not have access to the details of this account',
        defaultMessage:
            'You do not have access to the details of this account.',
    },
    headerUseAccount: {
        id: 'gateway.views.new-quote-account-search.Use this Account',
        defaultMessage: 'USE THIS ACCOUNT',
    },
    headerNumber: {
        id: 'gateway.views.new-quote-account-search.Number',
        defaultMessage: 'NUMBER',
    },
    headerName: {
        id: 'gateway.views.new-quote-account-search.Name',
        defaultMessage: 'NAME',
    },
    headerAddress: {
        id: 'gateway.views.new-quote-account-search.Address',
        defaultMessage: 'ACCOUNT ADDRESS',
    },
    startNewQuote: {
        id: 'gateway.views.new-quote-account-search.Start New Quote',
        defaultMessage: 'Start New Quote',
    },
    wantToExit: {
        id: 'gateway.controllers.NewQuoteCtrl.Are you sure you want to exit?',
        defaultMessage: 'Are you sure you want to exit?',
    },
    wantToExitMessage: {
        id: 'gateway.controllers.NewQuoteCtrl.The information you entered will be stored as a draft quote',
        defaultMessage: 'The information you entered will be stored as a draft quote. You must complete and submit this quote within 30 days of its Effective Date, or it will expire.',
    },
    cancelQuote: {
        id: 'gateway.controllers.NewQuoteCtrl.Cancel Quote',
        defaultMessage: 'Cancel Quote?',
    },
    cancelMessage: {
        id: 'gateway.controllers.NewQuoteCtrl.Are you sure you want to cancel the new quote?',
        defaultMessage: 'Are you sure you want to cancel the new quote?',
    },
    cancelMessageSubmission: {
        id: 'gateway.controllers.NewQuoteCtrl.Are you sure you want to cancel the quote?',
        defaultMessage: "Are you sure you want to cancel the quote?"
    },
    quoteTitleNewQuote: {
        id: 'gateway.views.new-quote.New Quote: New Account Details',
        defaultMessage: 'New Quote: New Account Details',
    },
    email: {
        id: 'gateway.views.new-quote.Email Address',
        defaultMessage: 'Email Address',
    },
    next: {
        id: 'gateway.views.new-quote.Next',
        defaultMessage: 'Next',
    },
    createQuote: {
        id: 'gateway.views.new-quote.Create Quote',
        defaultMessage: 'Create Quote',
    },
    productCode: {
        id: 'gateway.views.new-quote.Product Code',
        defaultMessage: 'Product Code',
    },
    existingAccountPolicyDetails: {
        id: 'gateway.views.new-quote.New Quote: Policy Details for Existing Account',
        defaultMessage: 'New Quote: Policy Details for Existing Account',
    },
    account: {
        id: 'gateway.views.new-quote.Account',
        defaultMessage: 'Account',
    },
    accountTypeErrorMessage: {
        id: 'gateway.views.new-quote.error.findAccount.account.type',
        defaultMessage: 'Account type must be a Company or a Person',
    },
    contactTypeCommercial: {
        id: 'gateway.views.new-quote-account-search.ContactType.Organization',
        defaultMessage: 'Organization',
    },
    contactTypeOrganization: {
        id: 'gateway.views.new-quote-account-search.ContactType.Organization',
        defaultMessage: 'Organization',
    },
    contactTypePersonal: {
        id: 'gateway.views.new-quote-account-search.ContactType.Person',
        defaultMessage: 'Personal',
    },
    contactTypeIndividual: {
        id: 'gateway.views.new-quote-account-search.ContactType.Individual',
        defaultMessage: 'Individual',
    },
    contactTypeEstate: {
        id: 'gateway.views.new-quote-account-search.ContactType.Estate',
        defaultMessage: 'Estate',
    },
    newAccountCreateErrorMessage: {
        id: 'gateway.views.new-quote.error.create.account',
        defaultMessage: 'Could not create the Account',
    },
    quoteQrganisation: {
        id: 'gateway.views.new-quote.Organization',
        defaultMessage: 'Organization',
    },
    noResults: {
        id: 'gateway.views.new-quote.No results found!',
        defaultMessage: 'No account found based on your search criteria.',
    },
    noLengthMatch: {
        id: 'gateway.views.new-quote.PersonNo results found! At least five letters are required',
        defaultMessage:
            'No account found based on your search criteria. Use the full last name or at least the first five letters of the last name.',
    },
    noResultsFound: {
        id: 'gateway.views.new-quote.No results found! At least five letters are required',
        defaultMessage:
            'No account found based on your search criteria. Use full Organization name or at least the first five letters of the organization name.',
    },
    producerCode: {
        id: 'gateway.views.new-quote.Producer Code Label',
        defaultMessage: 'Producer Code',
    },
    producerCodeName: {
        id: 'gateway.views.new-quote.Producer Code and Name',
        defaultMessage: 'Producer Code & Name',
    },
    requestedCoverageStartDate: {
        id: 'gateway.views.new-quote.Requested Coverage Start Date',
        defaultMessage: 'Requested Coverage Start Date',
    },
    effectiveDate: {
        id: 'gateway.views.new-quote.Effective Date',
        defaultMessage: 'Effective Date',
    },
    associationName: {
        id: 'gateway.views.new-quote.associationName',
        defaultMessage: 'Association Name',
    },
    individual: {
        id: 'gateway.views.new-quote.individual',
        defaultMessage: 'Individual',
    },
    dateMustmatch: {
        id: 'gateway.views.new-quote.Please enter a valid date (MM/DD/YYYY).',
        defaultMessage : 'Please enter a valid date (MM/DD/YYYY).'
    },
    errorDescription: {
        id: 'gateway.views.new-quote.error.create.submission.insufficient-permission',
        defaultMessage: 'This agency or user does not have permission to initiate or process this transaction.'
    }
});
